import React, {useContext, useEffect, useState} from "react";
import { Grid, FormChipsControlled, FormHelperText, TextField, Typography } from "@leap4/frontend";

import {UserContex} from "./userContex";
import {notification} from "../../../../common/data/enums";



export interface IDetailsFormProps {
    mode: "create" | "edit";
}

const DetailsForm = (props: IDetailsFormProps) => {
    const {
        user,
        setUser
    } = useContext(UserContex);

    const [notificationController, setNotificationController] = useState<{key: string, value: string}[]>([]);

    useEffect(() => {
        setNotificationController(user.notification.map((item) => ({key: item, value: item})));
    }, [user.notification]);

    const onChange = (e: any) => {
        let {name, value} = e.target;
        setUser({...user, [name]: value});
    }

    const onNotificationChange = (chipsArray) => {
        setUser({...user, notification: chipsArray});
    }


    return (
        <>
            <Typography fontFamily={"Quicksand"} fontWeight={600} variant="h5" style={{paddingBottom: "20px"}}>
                user view
            </Typography>

            <Grid container direction={"row"} justifyContent={"flex-start"} alignItems={"center"} gap={"20px"}>
                <Grid item xs={1.8} md={1.8}>
                    <FormHelperText>
                        Name
                    </FormHelperText>
                    <TextField
                        autoFocus
                        fullWidth
                        value={user?.name}
                        onChange={onChange}
                        size="medium"
                        variant="outlined"
                        name="name"
                        className={"gridItem"}
                    />
                </Grid>
                <Grid item xs={1.8} md={1.8}>
                    <FormHelperText>
                        email
                    </FormHelperText>
                    <TextField
                        autoFocus
                        fullWidth
                        value={user?.email}
                        onChange={onChange}
                        size="medium"
                        variant="outlined"
                        name="email"
                        className={"gridItem"}
                    />
                </Grid>
                <Grid item xs={1.8} md={1.8}>
                    <FormChipsControlled
                        valueKey={'key'}
                        labelKey={'value'}
                        inputName={'notification'}
                        optionsList={notification}
                        enableCreate={false}
                        pureCreate={false}
                        onUpdateItems={onNotificationChange}
                        disableCloseOnSelect={false}
                        stackProps={{width: '100%', style: {margin: '20px 0'}}}
                        controlledValue={notificationController}
                    />
                </Grid>
            </Grid>
        </>


    )
}

export {
    DetailsForm
}
